// K4 carousel images (360 visualizer)
import k4FrontDesktop from "../../../assets/img/models/k4/carousel/k4-front-desktop.webp";
import k4FrontMobile from "../../../assets/img/models/k4/carousel/k4-front-mobile.webp";
import k4BackDesktop from "../../../assets/img/models/k4/carousel/k4-back-desktop.webp";
import k4BackMobile from "../../../assets/img/models/k4/carousel/k4-back-mobile.webp";
import k4SideDesktop from "../../../assets/img/models/k4/carousel/k4-side-desktop.webp";
import k4SideMobile from "../../../assets/img/models/k4/carousel/k4-side-mobile.webp";
// K4 exterior images
import k4Exterior1 from "../../../assets/img/models/k4/exterior/k4-exterior-1.webp";
import k4Exterior2 from "../../../assets/img/models/k4/exterior/k4-exterior-2.webp";
import k4Exterior3 from "../../../assets/img/models/k4/exterior/k4-exterior-3.webp";
import k4Exterior4 from "../../../assets/img/models/k4/exterior/k4-exterior-4.webp";
import k4Exterior5 from "../../../assets/img/models/k4/exterior/k4-exterior-5.webp";
// K4 interior images
import k4Interior1 from "../../../assets/img/models/k4/interior/k4-interior-1.webp";
import k4Interior2 from "../../../assets/img/models/k4/interior/k4-interior-2.webp";
import k4Interior3 from "../../../assets/img/models/k4/interior/k4-interior-3.webp";
import k4Interior4 from "../../../assets/img/models/k4/interior/k4-interior-4.webp";
import k4Interior5 from "../../../assets/img/models/k4/interior/k4-interior-5.webp";
// K4 attributes
import k4AtributesMain from "../../../assets/img/models/k4/atributes/k4-atributes-main.webp";
// K4 hero image
import k4Hero from "../../../assets/img/models/k4/hero/k4-desktop.webp";
import k4HeroMobile from "../../../assets/img/models/k4/hero/k4-mobile.webp";
// K4 color images
import k4ColorFieryRed from "../../../assets/img/models/k4/colors/k4-color-fiery-red.webp";
import k4ColorAzureBlue from "../../../assets/img/models/k4/colors/k4-color-azure-blue.webp";
import k4ColorMorningHaze from "../../../assets/img/models/k4/colors/k4-color-morning-haze.webp";
import k4ColorAuroraBlackPearl from "../../../assets/img/models/k4/colors/k4-color-aurora-black-pearl.webp";
import k4ColorInterstellarGray from "../../../assets/img/models/k4/colors/k4-color-interstellar-gray.webp";
import k4ColorSteelGray from "../../../assets/img/models/k4/colors/k4-color-steel-gray.webp";
import k4ColorSnowWhitePearl from "../../../assets/img/models/k4/colors/k4-snow-white-pearl.webp";
// K4 Fichas
import k4Fichas from "../../../assets/fichas/Ficha técnica K4 Sedan.pdf";

export const k4Images = {

  carousel: {
    front: {
      desktop: k4FrontDesktop,
      mobile: k4FrontMobile,
    },
    back: {
      desktop: k4BackDesktop,
      mobile: k4BackMobile,
    },
    side: {
      desktop: k4SideDesktop,
      mobile: k4SideMobile,
    },
  },
  exterior: {
    image1: {
      desktop: k4Exterior1,
      mobile: k4Exterior1,
    },
    image2: {
      desktop: k4Exterior2,
      mobile: k4Exterior2,
    },
    image3: {
      desktop: k4Exterior3,
      mobile: k4Exterior3,
    },
    image4: {
      desktop: k4Exterior4,
      mobile: k4Exterior4,
    },
    image5: {
      desktop: k4Exterior5,
      mobile: k4Exterior5,
    },
  },
  interior: {
    image1: {
      desktop: k4Interior1,
      mobile: k4Interior1,
    },
    image2: {
      desktop: k4Interior2,
      mobile: k4Interior2,
    },
    image3: {
      desktop: k4Interior3,
      mobile: k4Interior3,
    },
    image4: {
      desktop: k4Interior4,
      mobile: k4Interior4,
    },
    image5: {
      desktop: k4Interior5,
      mobile: k4Interior5,
    },
  },
  colors: {
    fieryRed: k4ColorFieryRed,
    azureBlue: k4ColorAzureBlue,
    morningHaze: k4ColorMorningHaze,
    blackPearl: k4ColorAuroraBlackPearl,
    interstellarGray: k4ColorInterstellarGray,
    steelGray: k4ColorSteelGray,
    snowWhitePearl: k4ColorSnowWhitePearl,
  },
  attributes: {
    desktop: k4AtributesMain,
    mobile: k4AtributesMain,
  },
  heroImage: { desktop: k4Hero, mobile: k4HeroMobile },
  etiqueta: null,
  fichas: k4Fichas,
};
